module.exports = __webpack_public_path__ + "img/advantages.7a242f12.png";